import render from "./src/render"
$(document).ready(() => render())
